import { createStore } from "zustand/vanilla";


export interface IComponentsLoaded {
    headerLoaded: boolean;
    footerLoaded: boolean;
    appInitialized: boolean;
    setHeaderLoaded: () => void;
    setFooterLoaded: () => void;
    setAppInitialized: () => void;
}

export const componentsStore = createStore((set): IComponentsLoaded => {
    return {
        headerLoaded: false,
        footerLoaded: false,
        appInitialized: false,
        setHeaderLoaded: () => {
            set({ headerLoaded: true });
        },
        setFooterLoaded: () => {
            set({ footerLoaded: true });
        },
        setAppInitialized: () => {
            set({ appInitialized: true });
        }
    }
});


declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        componentsStore: any;
    }
}

window.componentsStore = componentsStore || {};
